export const voip_provider = [
  '26 38',
  `
<path d="M22.6875 0.25H3.3125C2.64969 0.250744 2.01424 0.514376 1.54556 0.983055C1.07688 1.45173 0.813244 2.08719 0.8125 2.75V35.25C0.813244 35.9128 1.07688 36.5483 1.54556 37.0169C2.01424 37.4856 2.64969 37.7493 3.3125 37.75H22.6875C23.3503 37.7493 23.9858 37.4856 24.4544 37.0169C24.9231 36.5483 25.1868 35.9128 25.1875 35.25V2.75C25.1868 2.08719 24.9231 1.45173 24.4544 0.983055C23.9858 0.514376 23.3503 0.250744 22.6875 0.25ZM22.6875 2.75V5.25H3.3125V2.75H22.6875ZM22.6875 7.75L22.6884 25.25H3.3125V7.75H22.6875ZM22.6875 35.25H3.3125V27.75H22.6887V35.25H22.6875Z" />
  `,
];
